import { useGetBoardCategoriesQuery } from '@/hooks/community/mobile/community.gql.impl';
import { parseBoardCategories } from '@/parsers/Communication/community';

const useGetBoardCategories = () => {
  const { data: categories } = useGetBoardCategoriesQuery(
    {},
    {
      select: (data) => parseBoardCategories(data),
    },
  );

  return {
    categories,
  };
};

export default useGetBoardCategories;
